import * as ko from "knockout";

import * as $ from "../jquery";

import { addBindingHandler } from "./util";


/**
 * Binding that makes the bound Pli field readonly when the value is true.
 *
 * A readonly field can be selected but cannot be modified.
 */
export interface PliReadOnlyFieldBinding {
    update: (element: HTMLElement, valueAccessor: () => ko. MaybeSubscribable<any>) => void;
}


const readOnlyFieldUpdaterKey = "__kopli__readOnlyFieldUpdater";


/** Set the function that should be used to make this element readonly. */
export function setFieldReadonlyUpdater(element: HTMLElement, updater: (element: HTMLElement, readonly: boolean) => void): void {
    if (!element) { throw new Error("pliReadOnlyField: Target element is required."); }
    if (typeof updater !== "function") { throw new Error("pliReadOnlyField: Updater must be a function."); }

    (<any>element)[readOnlyFieldUpdaterKey] = updater;
}


const pliReadOnlyFieldBinding: PliReadOnlyFieldBinding = {
    update: (element, valueAccessor) => {
        const readOnly = ko.unwrap(valueAccessor());

        const updater = (<any>element)[readOnlyFieldUpdaterKey];
        if (typeof updater === "function") {
            return updater(element, readOnly);
        }

        $(element).prop("readonly", readOnly);
        ko.utils.toggleDomNodeCssClass(element.parentElement.parentElement, "readOnly", readOnly);
    }
};


/**
 * Activates the 'pliReadOnlyField' binding.
 */
export function activatePliReadOnlyFieldBinding(): PliReadOnlyFieldBinding {
    return addBindingHandler("pliReadOnlyField", pliReadOnlyFieldBinding);
}



// WEBPACK FOOTER //
// /Users/johng/dev/web-pli/knockout/pliReadOnlyField.ts